import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { post, put } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import EditDialog from "../../../../Components/Common/EditDialog";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import formatTitleWithOptional from "../../../Scope1/OptionalFeild";
import { useUser } from "../../../../context/AuthContext";
// import formatTitleWithOptional from "../../OptionalFeild";

function Add({
  inputData,
  fetchData,
  id,
  title,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
  uniqueValues,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});
  const initialState = {
    consumptionPeriod: {
      month: data?.consumptionPeriod?.month || "",
      year: data?.consumptionPeriod?.year || "",
    },
    vendorRegistry: data?.vendorRegistry || "",
    projectIdOrName: data?.projectIdOrName || "",
    projectType: data?.projectType || "",
    creditsPurchased:
      data?.creditsPurchased === 0 ? 0 : data?.creditsPurchased || "",
    vintageYear: data?.vintageYear || "",
    appliedScopes: data?.appliedScopes || [],
    remarks: data?.remarks || "",
    documents: data?.documents || [],
    editRemarkReason: data?.editRemarkReason || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  // const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  // const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year

  // Options for appliedScopes field
  const appliedScopesOptions = [
    "Scope 1",
    "Scope 2",
    "Scope 3 - Category 1",
    "Scope 3 - Category 3",
    "Scope 3 - Category 5",
    "Scope 3 - Category 6",
    "Scope 3 - Category 7",
    "Scope 3 - Category 9",
  ];

  useEffect(() => {
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(data?.documents || []);
  }, [data, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  // Handle multi-select change for appliedScopes
  const handleAppliedScopesChange = (event) => {
    const value = event.target.value;

    // If "Select All" is chosen, select all or deselect all
    if (value.includes("Select All")) {
      setFormData((prev) => ({
        ...prev,
        appliedScopes:
          prev.appliedScopes.length === appliedScopesOptions.length
            ? []
            : appliedScopesOptions,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        appliedScopes: value,
      }));
    }
    setErrors((prev) => ({ ...prev, appliedScopes: "" }));
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    // setSelectedMonth(data?.monthYear?.month || "");
    // setSelectedYear(data?.monthYear?.year || "");
    setFormData(initialState);
    setFormData2(initialState); // Reset form data to initial state
    setUploadedFiles(data?.documents || []); // Reset uploaded files
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData2[key] === formData[key]
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      
      // Skip validation for fields that shouldn't be validated for admin users
      if (input.fieldName === "editRemarkReason" && !user?.endUser) {
        return; // Skip validation for admin users
      }
      
      // Skip validation for editRemarkReason when adding new data (not editing)
      if (input.fieldName === "editRemarkReason" && !id) {
        return; // Skip validation when adding new data
      }
      
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }
      if (input.fieldName === "documents" || input?.fieldName === "remarks")
        return;

      if (input.type === "number") {
        if (!validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }

      if (
        input?.fieldName === "appliedScopes" &&
        (!value || value.length === 0)
      )
        newErrors[input.fieldName] = `${input.title} is required`;

      // Additional checks for required fields
      if (input.type === "text" && (!value || value === "")) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      if (
        (input.fieldName === "vendorRegistry" ||
          input?.fieldName === "projectType") &&
        (value === "Others" || value === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      // Only validate editRemarkReason for end users when editing existing data
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;

    // Prepare data to send, including only fields with values
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
      // consumptionPeriod:{month:selectedMonth,year:selectedYear}
    };

    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }

    let method = id ? put : post;
    let url = id ? `${updateUrl}?Id=${id}` : addUrl;

    await method(url, dataToSend)
      .then((res) => {
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        fetchData();
        setFormData(initialState);
        setUploadedFiles([]);
        handleExitAgree();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.errors) {
          const errorMessages = err.response.data.errors
            .map((error) => error.msg)
            .join(", ");
          setsnackOpen({
            open: true,
            message: errorMessages,
            severity: "error",
          });
        }
      });
  };

  const renderInputField = (el) => {
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Month of energy export"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              // defaultMonth: formData?.consumptionPeriod?.month || "",
              // defaultYear: formData?.consumptionPeriod?.year || "",
            }}
          />
        </Box>
      );
    }

    if (el?.fieldName === "projectLocation") {
      return (
        <Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <InputField
              // title={el.title}
              title={formatTitleWithOptional(el.title)}
              handleChange={handleChange}
              placeholder={"City"}
              value={formData[el.fieldName]?.city || ""}
              errors={errors["city"]}
              fieldName={"city"}
              adornmentText={el.adornmentText || ""} // Pass error prop
            />
            <InputField
              // title={el.title}
              // title={formatTitleWithOptional(el.title)}
              mt={2.3}
              handleChange={handleChange}
              placeholder={"State"}
              value={formData[el.fieldName]?.state || ""}
              errors={errors["state"]}
              fieldName={"state"}
              adornmentText={el.adornmentText || ""} // Pass error prop
            />
          </Box>
          <InputField
            // title={el.title}
            // title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={"Country"}
            value={formData[el.fieldName]?.country || ""}
            errors={errors["country"]}
            fieldName={"country"}
            adornmentText={el.adornmentText || ""} // Pass error prop
          />
        </Box>
      );
    }

    // Special handling for appliedScopes field
    if (el.fieldName === "appliedScopes") {
      return (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            {formatTitleWithOptional(el.title)}
          </Typography>
          <Select
            multiple
            fullWidth
            size="small"
            style={{ marginBottom: "10px" }}
            value={formData.appliedScopes || []}
            onChange={handleAppliedScopesChange}
            displayEmpty
            error={!!errors.appliedScopes}
            renderValue={(selected) =>
              selected.length === 0 ? "Tap to Select" : selected.join(", ")
            }
          >
            <MenuItem value="" disabled>
              Tap to Select
            </MenuItem>
            <MenuItem value="Select All">Select All</MenuItem>
            {appliedScopesOptions.map((scope) => (
              <MenuItem key={scope} value={scope}>
                {scope}
              </MenuItem>
            ))}
          </Select>

          {formData?.appliedScopes?.map((value) => (
            <Chip
              key={value}
              label={value}
              sx={{
                bgcolor: "#1C486B",
                color: "white",
                height: "28px",
                m: 0.25,
                "& .MuiChip-deleteIcon": {
                  color: "white",
                  "&:hover": {
                    color: "white",
                  },
                },
              }}
              onDelete={() =>
                handleAppliedScopesChange({
                  target: {
                    value: formData?.appliedScopes?.filter((v) => v !== value),
                  },
                })
              }
            />
          ))}

          {errors.appliedScopes && (
            <Typography variant="body2" color="#D34040" sx={{ mt: 0.5 }}>
              {errors.appliedScopes}
            </Typography>
          )}
        </Box>
      );
    }

    if (el.options || el.type === "select") {
      return (
        <SelectField
          // title={el.title}
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          defaultValue={el.fieldName === "vintageYear" ? "Tap to Select" : undefined}
          errors={errors[el.fieldName]}
          field={el.field}
          isAddedNew={
            el?.fieldName === "projectType" ||
            el?.fieldName === "vendorRegistry"
              ? data && !el.options.includes(formData[el.fieldName])
              : false
          }
        />
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          // title={el.title}
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "remarks")
      return (
        <Multiline
          // title={el.title}
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null; // Don't render for other cases
    }

    return (
      <InputField
        // title={el.title}
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el?.type === "text" ? "Enter Text" : "Enter Number"}
        value={
          el.fieldName === "quantityConsumed"
            ? formData[el.fieldName]?.value
            : formData[el.fieldName] === 0
            ? 0
            : formData[el.fieldName] || ""
        }
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        adornmentText={el.adornmentText || ""} // Pass error prop
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "25.5rem", maxWidth: "100%" }}>
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? `Edit ${title}` : `Add ${title}`}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {list()}
    </Drawer>
  );
}

export default Add;
